import { useTranslation } from 'react-i18next';
import type { Lang } from '@/data/categories';

export const LANGS: { code: Lang; label: string; flag: string }[] = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'da', label: 'Dansk', flag: '🇩🇰' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
];

export function normalizeLang(raw: string): Lang {
  if (raw.startsWith('fr')) return 'fr';
  if (raw.startsWith('da')) return 'da';
  if (raw.startsWith('de')) return 'de';
  return 'en';
}

export function useLang(): Lang {
  const { i18n } = useTranslation();
  return normalizeLang(i18n.language || 'en');
}

export function useSetLang() {
  const { i18n } = useTranslation();
  return (lang: Lang) => {
    i18n.changeLanguage(lang);
    try {
      localStorage.setItem('lang', lang);
    } catch {
      // ignore storage errors
    }
  };
}